export default {
  getIssue: (state) => state.issue,
};
